function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-21.000000, -15.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.4714045,4.47140451 C10.7317541,4.21105498 10.7317541,3.78894499 10.4714045,3.52859546 C10.211055,3.26824593 9.78894501,3.26824593 9.52859549,3.52859546 L5.52859547,7.52859548 C5.26824594,7.78894501 5.26824594,8.21105499 5.52859547,8.47140452 L9.52859549,12.4714045 C9.78894501,12.7317541 10.211055,12.7317541 10.4714045,12.4714045 C10.7317541,12.211055 10.7317541,11.788945 10.4714045,11.5285955 L6.94280904,8 L10.4714045,4.47140451 Z"
}))))));

var SvgIconChevron = function SvgIconChevron(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "10px",
    viewBox: "0 0 6 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChevron, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-chevron.f98f3882.svg";
export { ForwardRef as ReactComponent };